import { render, staticRenderFns } from "./ShariahMatter.vue?vue&type=template&id=4cac293e&"
import script from "./ShariahMatter.vue?vue&type=script&lang=js&"
export * from "./ShariahMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports